import API from "../api";

// Get all discounts (admin)
export const listAllDiscounts = () => API.get("/admin/discounts");

// Get single discount
export const getDiscount = (id) => API.get(`/admin/discounts/${id}`);

// Create discount
export const createDiscount = (payload) =>
  API.post("/admin/discounts", payload);

// Update discount
export const updateDiscount = (id, payload) =>
  API.put(`/admin/discounts/${id}`, payload);

// Activate discount
export const activateDiscount = (id) =>
  API.put(`/admin/discounts/${id}/activate`);

// Archive discount
export const archiveDiscount = (id) =>
  API.put(`/admin/discounts/${id}/archive`);

// Delete discount
export const deleteDiscount = (id) => API.delete(`/admin/discounts/${id}`);

// Get applicable discounts (for enrollment) — role-aware path
export const getApplicableDiscounts = (params = {}, role = "ADMIN") => {
  const path =
    role === "MANAGER"
      ? "/manager/discounts/applicable"
      : role === "COACH"
        ? "/coach/discounts/applicable"
        : "/admin/discounts/applicable";
  return API.get(path, { params });
};
